import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
import { RouterModule } from '@angular/router';
import { UtilSharedModule } from '../util-shared/util-shared.module';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { ToolbarFilterSectionComponent } from './toolbar/apt-toolbar/toolbar-filter-section/toolbar-filter-section.component';
import { ToolbarBreadcrumbSectionComponent } from './toolbar/apt-toolbar/toolbar-breadcrumb-section/toolbar-breadcrumb-section.component';
import { ToolbarPageLayoutComponent } from './toolbar/toolbar-page-layout/toolbar-page-layout.component';
import { ToolbarOptionsSectionComponent } from './toolbar/apt-toolbar/toolbar-options-section/toolbar-options-section.component';
import { ToolbarChartsSectionComponent } from './toolbar/apt-toolbar/toolbar-charts-section/toolbar-charts-section.component';
import { ToolbarPageSectionComponent } from './toolbar/apt-toolbar/toolbar-page-section/toolbar-page-section.component';
import { AptToolbarComponent } from './toolbar/apt-toolbar/apt-toolbar.component';
import { ToolbarStackComponent } from './toolbar/apt-toolbar/toolbar-stack/toolbar-stack.component';
import { ToolbarSectionComponent } from './toolbar/apt-toolbar/toolbar-section/toolbar-section.component';
import { FileStatusListComponent } from './file-status-list';
import { SearchComponent } from './search/search.component';
import { MarkTextPipe } from './search/mark-text.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from './button/button.component';
import { AngularPipesModule } from '@aptitude/angular-pipes';
import { OptionsDropdownComponent } from './options-dropdown/options-dropdown.component';
import { ProgressHeaderModule } from './progress-header/progress-header.module';
import { PanelComponent } from './panel/panel.component';
import { PanelHeaderComponent } from './panel/panel-header/panel-header.component';
import { CollapsiblePanelDirective } from './panel/collapsible-panel.directive';
import { NgbCustomDateParserFormatterService } from '../../services/ngb-custom-date-parser-formatter/ngb-custom-date-parser-formatter.service';
import { NgbDatePickerComponent } from './date-picker/date-picker.component';
import { OnOffToggleComponent } from './on-off-toggle/on-off-toggle.component';
import { BasicPieComponent } from './basic-pie/basic-pie.component';
import { CollapsibleSectionComponent } from './collapsible-section/collapsible-section.component';
import { AptHeaderComponent } from './apt-header/apt-header.component';
import { ListToggleComponent } from './list-toggle/list-toggle.component';
import { OptionsTrayComponent } from './options-tray/options-tray.component';
import { ToolbarHeaderSectionComponent } from './toolbar/apt-toolbar/toolbar-header-section/toolbar-header-section.component';
import { BadgeComponent } from './badge/badge.component';

const components = [
  CollapsibleSectionComponent,
  NavComponent,
  BadgeComponent,
  ButtonComponent,
  OptionsDropdownComponent,
  FileUploadComponent,
  AptToolbarComponent,
  SearchComponent,
  MarkTextPipe,
  ToolbarBreadcrumbSectionComponent,
  ToolbarPageLayoutComponent,
  ToolbarOptionsSectionComponent,
  ToolbarChartsSectionComponent,
  ToolbarPageSectionComponent,
  ToolbarStackComponent,
  ToolbarSectionComponent,
  ToolbarFilterSectionComponent,
  ToolbarHeaderSectionComponent,
  FileStatusListComponent,
  PanelComponent,
  PanelHeaderComponent,
  CollapsiblePanelDirective,
  NgbDatePickerComponent,
  OnOffToggleComponent,
  BasicPieComponent,
  AptHeaderComponent,
  ListToggleComponent,
  OptionsTrayComponent,
];

@NgModule({
  declarations: components,
  exports: [...components, ProgressHeaderModule],
  imports: [
    AngularPipesModule,
    UtilSharedModule,
    CommonModule,
    RouterModule,
    FileUploadModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    ProgressHeaderModule,
    NgbDatepickerModule,
    NgbPopoverModule,
  ],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useClass: NgbCustomDateParserFormatterService,
    },
  ],
})
export class LayoutSharedModule {}
